import * as React from 'react'
import { statVariants, type StatVariantProps } from './Stat.variants'
import { cn } from '../../utils/cn'

export type StatProps = StatVariantProps &
  React.HTMLAttributes<HTMLDivElement> & {
    label: string
    n: number | string
  }

export default function Stat({ label, n, color, className, ...rest }: StatProps) {
  return (
    <div className={cn(statVariants({ color }), className)} {...rest}>
      <span
        className={cn(
          'w-2 h-2 rounded-full shrink-0',
          color === 'green' && 'bg-green',
          color === 'red' && 'bg-red',
          color === 'gold' && 'bg-gold',
          color === 'accent' && 'bg-accent',
          (!color || color === 'neutral') && 'bg-ink-3',
        )}
      />
      <span className="font-mono text-base font-semibold text-ink">{n}</span>
      <span className="text-xs text-ink-3">{label}</span>
    </div>
  )
}
